import type { SkillGroup } from '@/types/content'

/** Technical skills, grouped as the CV groups them. */
export const skillGroups: readonly SkillGroup[] = [
  {
    id: 'programming',
    name: 'Programming',
    items: ['C++', 'JAVA', 'JavaScript', 'Python', 'PHP'],
  },
  {
    id: 'networking',
    name: 'Networking & Infrastructure',
    items: [
      'TCP/IP', 'PPP', 'LTE', 'IPv4', 'VPN', 'GSM/GPRS',
      'Cisco', 'Huawei', 'Fortinet', 'Ansible', 'Bash',
    ],
  },
  {
    id: 'cloud',
    name: 'Cloud & DevOps',
    items: [
      'AWS', 'Docker', 'Kubernetes', 'Jenkins', 'Terraform',
      'GitHub Actions', 'Grafana', 'Prometheus',
    ],
  },
  {
    id: 'embedded',
    name: 'Embedded Systems',
    items: [
      'Raspberry Pi', 'AOSP', 'Android TV', 'UART/USB Serial',
      'Embedded Linux', 'Arduino', 'Python (Pyserial)',
    ],
  },
  {
    id: 'architecture',
    name: 'Software Architecture',
    items: ['UML', 'BPMN', 'GoF', 'ERD', 'MVC', 'Microservices', 'REST APIs'],
  },
  {
    id: 'development',
    name: 'Development',
    items: [
      'Spring Boot', 'ExpressJS', 'ReactJS', 'GraphQL',
      'PostgreSQL', 'Flutter', 'PHP', 'Python',
    ],
  },
  {
    id: 'security',
    name: 'Security',
    items: [
      'OWASP', 'JWT', 'SSL/TLS', 'WAF',
      'Role-based Access Control', 'Biometric Authentication',
    ],
  },
  {
    id: 'design',
    name: 'Design',
    items: ['Figma', 'Adobe Illustrator', 'Adobe Photoshop'],
  },
]
